import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeRequestModal, openRequestModal } from '../../actions/modals';
import ComponentTable from '../../components/ComponentTable';

import IconButton from '@mui/material/IconButton';
import { Edit, ExitToApp, MonetizationOn } from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { withTranslation } from 'react-i18next';
import { getUsers } from '../../actions/getUsers';
import { getGroupsFromSelect, getTeachersFromSelect } from '../../actions/groups';
import { emulation } from '../../actions/user';
import ModelService from './../../services/models.service';
import StudentsService from './../../services/students.service';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { apiService } from '../../services/requestV2.service';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import HistoryIcon from '@mui/icons-material/History';

class StudentsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: '',
        };
    }

    componentDidMount() {
        apiService.setCurrentPage('/students');
        this.props.getTeachersFromSelect(false, { size: 9999 });
    }

    componentWillUnmount() {
        apiService.cancelAllRequests('/students');
    }

    handleBack() {
        this.props.history.push('/dashboard');
    }
    render() {
        // Перевірка id користувача
        const { user } = this.props;
        // console.log(user.info.role_id)
        // const isUserIdOne = user.info.role_id === 1;
        // const isUserIdOne = true;

        const { t } = this.props;
        const table = this.props.AsyncTable && this.props.AsyncTable.table && this.props.AsyncTable.table.data;

        const actions = [
            {
                title: t('modals_name.edit'),
                onClick: id =>
                    this.props.openRequestModal({
                        opened: true,
                        data: {
                            id: id,
                            role_id: 5,
                            header: t('modals_name.edit'),
                            modaltype: 'EditUserModal',
                        },
                    }),
                Icon: Edit,
            },
            {
                title: t('sidebar.discounts'),
                onClick: id => {
                    const user = table.find(el => el.id === id);
                    return this.props.openRequestModal({
                        opened: true,
                        data: {
                            id: id,
                            header: `${t('sidebar.discounts')} | ${user.first_name} ${user.last_name}`,
                            user_status: user.status,
                            modaltype: 'EditDiscountsModal',
                        },
                    });
                },
                Icon: MonetizationOn,
            },
            {
                title: 'SOROBANK',
                onClick: id => {
                    this.props.history.push(`/students/bank/${id}/student`);
                },
                Icon: AttachMoneyIcon,
            },
            {
                title: t('groups.assign_book'),
                onClick: id => {
                    const user = table.find(el => el.id === id);
                    return this.props.openRequestModal({
                        opened: true,
                        data: {
                            id: id,
                            // eslint-disable-next-line
                            header: `${t('groups.assign_book')} | ${user.first_name} ${user.last_name}`,
                            modaltype: 'AssignBookModal',
                        },
                    });
                },
                Icon: MenuBookIcon,
            },
            {
                title: t('books.assignmentHistory'),
                onClick: id => {
                    this.props.history.push(`/students/textbookHistory/${id}`);
                },
                Icon: HistoryIcon,
            },
            {
                title: t('groups.completedHwCycles'),
                onClick: id => {
                    this.props.history.push(`/students/hwCyclesStats/${id}`);
                },
                Icon: TaskAltIcon,
            },
            {
                // title: t('table.log_in_as'),
                title: t('table.emulation'),
                onClick: id =>
                    this.props.emulation({
                        id,
                        path: window.location.pathname,
                    }),
                Icon: ExitToApp,
            },
        ];

        const paramsItems = ['discounts', 'birthdate', 'day', 'week', 'month', 'quarter'];

        const actionsNewStudents = [
            {
                title: t('modals_name.edit'),
                onClick: id =>
                    this.props.openRequestModal({
                        opened: true,
                        data: {
                            id: id,
                            role_id: 5,
                            header: t('modals_name.edit'),
                            modaltype: 'EditUserModal',
                        },
                    }),
                Icon: Edit,
            },
        ];
        const params = this.props.match.params.type;
        return (
            <Fragment>
                <h2 className="container-header">
                    {paramsItems.includes(params) || this.state.filter ? (
                        <IconButton
                            aria-label="add to favorites"
                            className="delete_icon"
                            onClick={() => this.handleBack()}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                    ) : null}
                    {paramsItems.includes(params)
                        ? `${t('groups.students')} | ${
                              params === 'discounts'
                                  ? t('sidebar.discounts')
                                  : params === 'day' || params === 'week' || params === 'month' || params === 'quarter'
                                  ? t('dashboard.new_students')
                                  : t('dashboard.birth_date')
                          }`
                        : t('groups.students')}
                </h2>
                {params === 'discounts' ? (
                    <ComponentTable
                        source={{
                            firstLoad: () =>
                                this.props.getGroupsFromSelect(false, {
                                    size: 9999,
                                }),
                            getData: (page, size, sort, filter) =>
                                StudentsService.DiscountList(false, {
                                    page: page || 0,
                                    size: size || 10,
                                    orderBy: (sort && sort.orderBy) || null,
                                    order: (sort && sort.order) || null,
                                    filter: filter,
                                }),
                            getModel: () =>
                                ModelService.StudentsDiscount(false, {
                                    role_id: 5,
                                }),
                        }}
                        actions={actions}
                        selectable={true}
                        enableFilter
                        title={t('sidebar.students')}
                        enableSettings
                        toolbarvisible={true}
                    />
                ) : null}
                {params === 'birthdate' ? (
                    <ComponentTable
                        source={{
                            firstLoad: () =>
                                this.props.getGroupsFromSelect(false, {
                                    size: 9999,
                                }),
                            getData: (page, size, sort, filter) =>
                                StudentsService.BirthdayList(false, {
                                    page: page || 0,
                                    size: size || 10,
                                    orderBy: (sort && sort.orderBy) || null,
                                    order: (sort && sort.order) || null,
                                    filter,
                                }),
                            getModel: () =>
                                ModelService.StudentsBirthday(false, {
                                    role_id: 5,
                                }),
                        }}
                        actions={actions}
                        selectable={true}
                        enableFilter
                        title={t('dashboard.birth_date')}
                        enableSettings
                        toolbarvisible={true}
                    />
                ) : null}

                {params !== 'discounts' && params !== 'birthdate' && paramsItems.includes(params) ? (
                    <ComponentTable
                        source={{
                            firstLoad: () =>
                                this.props.getGroupsFromSelect(false, {
                                    size: 9999,
                                }),
                            getData: (page, size, sort, filter) =>
                                StudentsService.NewStudentsCreated(false, {
                                    page: page || 0,
                                    size: size || 10,
                                    orderBy: (sort && sort.orderBy) || null,
                                    order: (sort && sort.order) || null,
                                    filter,
                                    type: params,
                                }),
                            getModel: () =>
                                ModelService.CreatedStudents(false, {
                                    role_id: 5,
                                }),
                        }}
                        actions={actionsNewStudents}
                        selectable={true}
                        enableFilter
                        headerTable={t(`dashboard.per_${params}`)}
                        enableSettings
                        toolbarvisible={true}
                    />
                ) : null}
                {!params ? (
                    <ComponentTable
                        source={{
                            firstLoad: () =>
                                this.props.getGroupsFromSelect(false, {
                                    size: 9999,
                                }),
                            getData: (page, size, sort, filter) =>
                                StudentsService.StudentsList(false, {
                                    page: page || 0,
                                    size: size || 10,
                                    orderBy: (sort && sort.orderBy) || 'last_name',
                                    order: (sort && sort.order) || 'asc',
                                    filter: filter,
                                }),
                            getModel: () =>
                                ModelService.StudentsList(false, {
                                    role_id: 5,
                                }),
                        }}
                        actions={actions}
                        selectable={true}
                        enableFilter
                        typeTable="iconicStudents"
                        title={t('sidebar.students')}
                        enableSettings
                        toolbarvisible={true}
                    />
                ) : null}
            </Fragment>
        );
    }
}

const widthConnect = connect(
    state => ({
        user: state.user,
        modalWindow: state.modalWindow,
        users: state.users,
        AsyncTable: state.AsyncTable,
    }),
    dispatch =>
        bindActionCreators(
            {
                openRequestModal,
                closeRequestModal,
                getUsers,
                emulation,
                getTeachersFromSelect,
                getGroupsFromSelect,
            },
            dispatch
        )
);

export default withTranslation()(widthConnect(StudentsPage));
